module.exports = __webpack_public_path__ + "static/media/thirdfloor2.786f7cf6.png";